import { combineReducers } from 'redux';
// import portfolios from './portfolios';
import jaws from './jaws';
import components from './components';
// import overviewChart from './overviewChart';
import suggest from './suggest';
import sparklines from './sparklines';
import user from './user';
import reports from './admin/reports';
import adminUsers from './admin/users';
import adminCustomers from './admin/customers';
import adminAuditReport from './admin/auditReport';
import adminAuditSearch from './admin/auditSearch';
import watchlists from './watchlists';
import graphdata from './graphdata';
import instruments from './instruments';
import orders from './orders';
import sniplets from './sniplets';
import alerts from './alerts';
import fictivePortfolios from './fictivePortfolios';
import exchange from 'state/exchange';
import form from './form';

const rootReducer = combineReducers({
  // portfolios,
  jaws,
  components,
  // overviewChart,
  suggest,
  sparklines,
  user,
  reports,
  adminUsers,
  adminCustomers,
  adminAuditReport,
  adminAuditSearch,
  watchlists,
  graphdata,
  instruments,
  orders,
  sniplets,
  alerts,
  fictivePortfolios,
  exchange,
  form,
});

export default rootReducer;
